module.exports = __webpack_public_path__ + "static/img/pic_VIPYS_03@2x.8a88b16c.png";